export default __webpack_public_path__ + "static/media/Spotify_placeholder.46b725e9.png";